import { defineMessages } from 'react-intl';

export default defineMessages({
    farmDetailsAddFarmer: {
        id:'quoteandbind.farm.views.farm-package-details.Add Farmer',
        defaultMessage:'Add Farmer'
    },
    farmDetailsAddAnotherFarmer: {
        id:'quoteandbind.farm.views.farm-package-details.Add Another Farmer Details?',
        defaultMessage:'Add Farmer Details?'
    },
    farmerCount: {
        id: 'quoteandbind.farm.views.farm-package-details.Farmer :',
        defaultMessage: 'Farmer : { count }'
    },
    farmerInsured: {
        id: 'quoteandbind.farm.views.farm-package-details.Farmer Insured',
        defaultMessage: 'Farmer Insured'
    },
    farmerBeneficiary: {
        id: 'quoteandbind.farm.views.farm-package-details.Beneficiary',
        defaultMessage: 'Beneficiary'
    },
    farmerCoverages: {
        id: 'quoteandbind.farm.views.farm-package-details.Coverages',
        defaultMessage: 'Coverages'
    },
    farmerBrokerCoverages: {
        id: 'quoteandbind.farm.views.farm-package-details.Broker Endorsements',
        defaultMessage: 'Broker Endorsements'
    },
    farmerAccidents: {
        id: 'quoteandbind.farm.views.farm-package-details.Farmer Accidents',
        defaultMessage: 'Farmer\'s Accident'
    },
    farmDetailsDeleteFarmer: {
        id:'quoteandbind.farm.views.farm-package-details.Delete',
        defaultMessage:'Delete'
    },
    farmDetailsSave: {
        id:'quoteandbind.farm.views.farm-package-details.Save',
        defaultMessage:'Save'
    },
    farmerInsuredAge: {
        id:'quoteandbind.farm.views.farm-package-details.Insured\'s Age',
        defaultMessage:'Insured\'s Age'
    },
    farmerInsuredAge: {
        id:'quoteandbind.farm.views.farm-package-details.Insured\'s Address',
        defaultMessage:'Insured\'s Address'
    },
    farmerBeneficiaryAge: {
        id:'quoteandbind.farm.views.farm-package-details.Beneficiary\'s Age',
        defaultMessage:'Beneficiary\'s Age'
    },
    farmerBeneficiaryAge: {
        id:'quoteandbind.farm.views.farm-package-details.Beneficiary\'s Address',
        defaultMessage:'Beneficiary\'s Address'
    },

});
